import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import ProductsPageRoute from 'apps/productsPages/utils/ProductsPageRoute';

import FopList from '../components/FopList';

export default withRouter(connect(
  (state, ownProps) => ({
    productsBySku: ownProps.productsBySku || state.products.productsBySku,
    productsPageRoute: new ProductsPageRoute(ownProps.location, ownProps.params),
  })
)(FopList));
